export default __webpack_public_path__ + "static/media/3 1.6f411df7.svg";